import JSZip from 'jszip'
import type { CapturedSlide } from '../../../lib/renderService'

function base64ToBytes(base64: string): Uint8Array {
  const binary = atob(base64)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i)
  return bytes
}

/** Monta um .zip com um PNG por tela (numerado pela ordem da timeline) e dispara o download. */
export async function downloadSlidesAsZip(slides: CapturedSlide[], materiaSlug: string): Promise<void> {
  const zip = new JSZip()
  slides
    .slice()
    .sort((a, b) => a.index - b.index)
    .forEach((slide, i) => {
      const num = String(i + 1).padStart(2, '0')
      zip.file(`${num}-${slide.templateId}.png`, base64ToBytes(slide.base64))
    })

  const blob = await zip.generateAsync({ type: 'blob' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `${materiaSlug || 'materia'}.zip`
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}
